function DefaultProfileIcon() {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="9.5" cy="9.5" r="9.5" fill="#F7F8F9" />
      <path
        d="M13.4583 7.12508C13.4583 6.03179 13.015 5.04221 12.2993 4.32654C11.5829 3.61008 10.5933 3.16675 9.5 3.16675C8.40671 3.16675 7.41712 3.61008 6.70067 4.32654C5.985 5.04221 5.54167 6.03179 5.54167 7.12508C5.54167 8.21837 5.985 9.20796 6.70067 9.92362C7.41712 10.6401 8.40671 11.0834 9.5 11.0834C10.5933 11.0834 11.5829 10.6401 12.2993 9.92362C12.6673 9.55649 12.9592 9.12026 13.1581 8.64C13.357 8.15974 13.459 7.6449 13.4583 7.12508ZM4.75 15.0417C4.75 15.8334 6.53125 16.6251 9.5 16.6251C12.2851 16.6251 14.25 15.8334 14.25 15.0417C14.25 13.4584 12.3864 11.8751 9.5 11.8751C6.53125 11.8751 4.75 13.4584 4.75 15.0417Z"
        fill="#CCCCCC"
      />
    </svg>
  );
}
export default DefaultProfileIcon;
